<template>
    <div class="body" v-if="is_loading">
        <!-- 네비게이션 -->
        <Head :time="current_time" :total_question="total_question" :current_question="current_question" @next="next" :total_part="total_part" :current_part="part"></Head>
        <div class="wrap body-con part02">
            <h2>다음 단어들을 조합하여 문장을 완성하세요. </h2>
            <!-- <h3>{{answer}}<span @click="backspace()" v-if="is_undo"><i class="fas fa-undo"></i></span></h3> -->
            <div class="answer_div">
<h3>{{answer}}</h3>
<span @click="backspace()" v-if="is_undo"><i class="fas fa-undo"></i></span>
            </div>
            <ul>
                <li class="btn-line" :class="{'on' : value == select_item[key-1]}"
                v-for="(value,key) in modules.part[this.part][current_question].statement" :key="key" @click="partTwoCheck(value,key)">{{value}}</li>
            </ul>
        </div>

        <div class="wrap">
            <div class="btn-fixed" v-if="is_next"><button class="btn-full"  @click="next()">NEXT</button></div>
            <div class="btn-fixed"  v-if="!is_next"><button class="btn-full on" >NEXT</button></div>
        </div>

        <!-- 푸터 -->
        <Footer></Footer>
    </div>
</template>
<script>
import Footer from '@/components/footer.vue';
import Head from '@/components/inc_head.vue';
export default {
    name: 'part02',
    components: {
        Footer,
        Head
    },
    data: () => ({
        current_time : {time:0},
        total_question:0,
        current_question:0,
        is_loading:false,
        modules:{},
        part:2,
        answer:"",
        type:"",
        total_part:{part:0},
        is_update:0,
        select_item:[],
        is_next:false,
        is_undo:false,
        memetos:[]
    }),
    mounted() {
       this.type = this.$route.params.type;
       this.getQuestion();
    },
    methods: {
        getQuestion(){
            var params = {
                type:this.type,
                part:this.part
            }
            this.axios.get(this.axios.root + "/rest/module_info/getQuestions",{params:params}).then((res)=>{
                console.log(JSON.stringify(res.data.data));
                if(res.data.err == 0){
                    // console.log(res);
                    this.total_part = {part:parseInt(res.data.data.total_part)};
                    this.total_question = res.data.data.total_question;
                    this.modules = res.data.data.modules;
                    this.current_question = parseInt(res.data.data.submit_answer);
                    this.current_time.time = this.modules.part[this.part][this.current_question].second * 1000;
                    this.is_loading = true;
                }else if(res.data.err == 5000){
                    alert(res.data.err_msg);
                    sessionStorage.clear();
                    location.href="/intro";
                }else if(res.data.err == 6001){
                    alert(res.data.err_msg);
                    this.$router.push('/part03/'+this.type);
                }else{
                    alert(res.data.err_msg);
                    return false;
                }
            })
        },
        test(){
            this.current_time = 15000;
        },
        next(){
            // this.current_question++;

            this.answer = this.answer.trim();
            var params = {
                part :this.part,
                number : (this.current_question+1),
                type:this.type,
                student_idx:sessionStorage.getItem("student_idx"),
                answer:this.answer
            }
            // console.log(params);
            this.axios.post(this.axios.root + "/rest/access/answerSubmit",params).then((res) => {
                // console.log(res);
                if(res.data.err == 0){
                    this.is_undo = false;
                    this.answer = "";
                    this.memetos = [];
                    this.select_item = [];
                    if((this.current_question + 1) == this.modules.part[this.part].length){
                        this.$router.push('/part03/'+this.type);
                    }else{
                        this.current_question++;
                        this.current_time = {time:this.modules.part[this.part][this.current_question].second * 1000};
                    }
                }else{
                    alert(res.data.err_msg);
                    return false;
                }
            });
        },
        partTwoCheck(value,key){
            if(value != this.select_item[key-1]){
                this.answer += value + " "
                this.select_item[key-1] = value;
                this.memetos.push(value)
                if(Object.keys(this.modules.part[this.part][this.current_question].statement).length == this.memetos.length){
                    this.is_next = true;
                }else{
                    this.is_next = false;
                }
                if(this.memetos.length > 0){
                    this.is_undo = true;
                }else{
                    this.is_undo = false;
                }
            }
        },
        backspace(){
            // console.log(this.memetos);
            this.answer = this.answer.trim();
            var lastmemto  = this.memetos.pop();
            this.answer = '';
            for(var i = 0; i < this.memetos.length; i++){
                this.answer += this.memetos[i] + ' ';
                console.log(this.memetos[i]);
            }
            for(var j = 0; j < this.select_item.length; j++){
                if(this.select_item[j] == lastmemto){
                    this.select_item[j] = '';
                }
            }
            if(Object.keys(this.modules.part[this.part][this.current_question].statement).length == this.memetos.length){
                this.is_next = true;
            }else{
                this.is_next = false;
            }
            if(this.memetos.length > 0){
                this.is_undo = true;
            }else{
                this.is_undo = false;
            }
        }
    }
}
</script>